
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestzantaclawyers/contact-us",
      function () {
        return require("private-next-pages/bestzantaclawyers/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestzantaclawyers/contact-us"])
      });
    }
  